import config from "config";
import _ from "lodash";
import { Divider, List, ListItem, MenuItem } from "material-ui";
import moment from "moment-timezone";
import queryString from "query-string";
import React from "react";
import { Link } from "react-router";

import userService from "../../services/user-service";
import styles from "./SideBarList.scss";

const sideBarItemsList = [
  {
    requiredPermissions: ["analytics_view"],
    label: "Ubicuity",
    content: [
      {
        content: "/opportunities",
        label: "Overview",
      },
      // {
      //   content: "/cross-channel-analysis",
      //   label: "Cross Channel Analytics",
      // },
      {
        content: "/overall-summary",
        label: "Customer Analytics",
      },
      {
        content: "/purchases-clustering-analytics",
        label: "Lifecycle",
      },
      {
        content: "/category-analytics",
        label: "Store Analytics",
      },
      {
        content: "/sales-analytics",
        label: "Campaign Analytics",
      },
      {
        content: "/customer-details/mobile=",
        label: "Customer 360",
      },
    ],
  },
  {
    requiredPermissions: ["analytics_view", "loyalty"],
    label: "RetenSee",
    content: [
      {
        content: "/loyalty-tiers",
        label: "Loyalty Tiers",
      },
      {
        label: "Loyalty Configuration",
        content: "/loyalty-config",
      },
      {
        content: "/loyalty-summary",
        label: "Earn / Burn / Report",
      },
      // {
      //   content: "/loyalty-tiers-stat",
      //   label: "Loyalty Tiers Stat",
      // },
    ],
  },
  {
    requiredPermissions: ["analytics_view", "journey_builder"],
    label: "Journify",
    content: [
      {
        label: "Create Journey",
        content: `${config.casaWebAppUrl}/journey/create`,
        external: true,
      },
      {
        label: "List Journeys",
        content: `${config.casaWebAppUrl}/journey/list`,
        external: true,
      },
    ],
  },
  {
    requiredPermissions: ["analytics_view", "social_media_rewards"],
    label: "Social Media Engagements",
    content: [
      {
        content: "/social-media-engagements/create",
        label: "Configure Engagements",
      },
      {
        content: "/social-media-engagements",
        label: "Engagements Summary",
      },
    ],
  },
  {
    requiredPermissions: ["invoice-creator"],
    label: "Invoice Creator",
    content: "/invoice-creator",
  },
  {
    requiredPermissions: ["analytics_view", "Offers-management"],
    label: "Offerio",
    content: [
      {
        content: "/offers/create",
        label: "Create Offer",
      },
      {
        content: "/offers-analytics",
        label: "Offers Analytics",
      },
      // {
      //   content: "/customer-offers-search",
      //   label: "Customer Offers Search",
      // },
      {
        content: "/offers",
        label: "Manage Offers",
      },
      {
        content: "/offers/search",
        label: "Customer Offers Search",
      },
    ],
  },
  {
    requiredPermissions: ["analytics_view", "b2b_offers_management"],
    label: "B2B Offers Flow",
    content: [
      {
        content: "/b2b-offer-flow",
        label: "Create B2B Offer Flow",
      },
      {
        content: "/b2b-offers-report",
        label: "B2B Offer Flows Report",
      },
    ],
  },
  {
    requiredPermissions: ["analytics_view", "Flipbook"],
    label: "Flipsell",
    content: [
      {
        content: "/flipbook/view-example",
        label: "Create/View",
      },
    ],
  },
  {
    requiredPermissions: ["analytics_view", "label_printing"],
    label: "Label Printing",
    content: "/labeling",
  },
  {
    requiredPermissions: ["analytics_view", "chatbot-interests"],
    label: "Chatbot interests",
    content: "/chatbot-interests",
  },
  {
    requiredPermissions: ["lead_manage"],
    label: "Intelliclose",
    // initiallyOpen: true,
    content: [
      {
        requiredPermissions: ["lead_create"],
        content: "/new-lead/customerInfo=",
        label: "Create New Lead",
      },
      // {
      //   requiredPermissions: ["overall-lead-management"],
      //   content: "/lead-management",
      //   label: "Overall Lead Management",
      // },
      {
        content: `/state-manager/walkinFilter/${queryString.stringify(
          {
            startDate: moment().subtract(1, "days").format("YYYY-MMM-DD"),
            endDate: moment().format("YYYY-MMM-DD"),
          },
          { arrayFormat: "bracket" }
        )}`,
        label: "Manage",
      },
      // {
      //   content: "/lead-distribution-analytics",
      //   label: "Distributions",
      // },
      // {
      //   content: "/lead-closure-analytics",
      //   label: "Closure Analytics",
      // },
      // {
      //   content: "/lead-conversion-days-analytics",
      //   label: "Conversion Days",
      // },
      // {
      //   content: "/lead-management-reports",
      //   label: "Reports",
      // },
      {
        content: "/lms-configs",
        label: "LMS Master Settings",
      },
    ],
  },
  {
    requiredPermissions: ["order-management"],
    label: "Order Management",
    content: "/order-management",
  },
  {
    requiredPermissions: ["business-to-business-site"],
    label: "B2B",
    content: `${config.b2bUrl.fabindia}`,
    external: true,
  },
  {
    requiredPermissions: ["commerce-connect"],
    label: "Pimkart",
    content: `${config.commerceConnect}/admin/products`,
    external: true,
  },
  {
    requiredPermissions: ["order-management"],
    label: "B2B Orders",
    content: "http://localhost:3080/admin/orders",
    external: true,
  },
  {
    requiredPermissions: ["order-capture"],
    label: "Order Capture",
    content: "/order-capture",
  },
  {
    requiredPermissions: ["captive-portal"],
    label: "Captive Portal",
    content: "/captive-portal",
  },
  {
    requiredPermissions: ["refer_users"],
    label: "Send Referral Invites",
    content: "/rse-referral",
  },
  {
    label: "Campaign Delight",
    requiredPermissions: ["campaign_manage"],
    content: [
      {
        label: "Create Cohorts",
        content: "/create-cohorts",
      },
      {
        label: "Manage Cohorts",
        content: "/manage-cohorts",
      },
      {
        label: "Create Campaigns",
        content: "/campaign/create",
      },
      {
        label: "Manage Campaigns",
        content: "/campaign/list",
      },
      {
        label: "Latency Based Campaigns",
        content: "/latency-campaign/create",
      },
      {
        label: " Upload Pictures",
        content: "/campaign-forms/staticFileExchange",
      },
    ],
  },
  {
    label: "Form Management",
    requiredPermissions: ["form_manage"],
    content: [
      {
        label: "Create Forms",
        content: "/campaign-form/create",
      },
      {
        label: "List Forms",
        content: "/campaign-form/list",
      },
    ],
  },
  {
    label: "PWA Configuration",
    requiredPermissions: ["manage-shoppersDelight-pwa"],
    content: [
      {
        label: "Manage Config",
        content: "personify",
      },
    ],
  },
  {
    label: "Configuration",
    requiredPermissions: ["config_manage"],
    content: [
      {
        label: "Permissions",
        content: "/role-config-v1",
      },
      {
        label: "List Users",
        content: "/user-list",
      },
      {
        label: "Email Configuration",
        content: "/email-config",
      },
      // {
      //   label: "PWA Configuration",
      //   content: "personify",
      // },
      {
        label: "Tenant Configuration",
        content: "/tenant-config",
      },
      {
        label: "Field Configuration",
        content: "/tenant-field-mapping",
      },
      {
        label: "SMS Configuration",
        content: "/sms-config",
      },
      {
        label: "Muffler Configuration",
        content: "/muffler-config",
      },
      {
        label: "Stores Configuration",
        content: "/stores-config",
      },
      {
        label: "User Configuration",
        content: "/account-management",
      },
      {
        label: "Group Configuration",
        content: "/create-customer-group",
      },
      {
        label: "Customer Migrate",
        content: "/migrate-customers",
      },
    ],
  },
  {
    label: "Reports",
    requiredPermissions: ["list-report"],
    content: [
      {
        label: "Transaction wise report",
        requiredPermissions: ["transaction-report"],
        content: "/reports/transaction-report",
      },
      {
        label: "Fraud report",
        requiredPermissions: ["fraud-report"],
        content: "/reports/fraud-report",
      },
      // {
      //   label: "Member report (loyalty)",
      //   requiredPermissions: ["member-loyalty-report"],
      //   content: "/reports/member-loyalty-report",
      // },
      {
        label: "Member Report",
        requiredPermissions: ["member-bill-report"],
        content: "/reports/member-bill-report",
      },
      {
        label: "Store Health Dashborad",
        requiredPermissions: ["store-health-dashboard"],
        content: "/reports/store-health-dashboard",
      },
      {
        label: "Loyalty Liability Report",
        requiredPermissions: ["loyalty-liability-report"],
        content: "/reports/loyalty-liability-report",
      },
      {
        label: "KPI report",
        content: "/reports/kpi-report",
      },
      {
        label: "Campaign report",
        requiredPermissions: ["campaign-tenant-report"],
        content: "/reports/campaign-report",
      },
      {
        label: "Offer report",
        requiredPermissions: ["offer-tenant-report"],
        content: "/reports/offer-report",
      },
    ],
  },
  {
    label: "Subscription",
    requiredPermissions: ["Flipbook", "config_manage"],
    content: "/subscription-view",
  },
  {
    label: "Import/Export",
    requiredPermissions: ["data_manage"],
    content: [
      {
        label: "Upload Data",
        content: "/data-upload",
      },
      {
        label: "Upload Logs",
        content: "/upload-logs",
      },
      {
        label: "Large Data Uploads",
        content: "/parallel-upload",
      },
      {
        label: "Download User Data",
        content: "/user-data-download",
      },
    ],
  },
  {
    label: "Field Sales Assist",
    requiredPermissions: ["sfa"],
    content: "/field-sales-assist",
  },
  {
    label: "Logout",
    content: "/logout",
  },
];

// recursively get the MenuItems/ListItem for an entry
const getListContent = (sideBarItem, currentUserPermissions, onClick) => {
  // isAuthorized is true when requiredPermissions is a subset of currentUserPermissions
  const pathname = location.pathname;

  const isAuthorized =
    _.difference(sideBarItem.requiredPermissions, currentUserPermissions)
      .length === 0;
  if (!isAuthorized) {
    return;
  }
  if (
    typeof sideBarItem.content === "string" ||
    _.isPlainObject(sideBarItem.content)
  ) {
    return (
      <MenuItem
        key={sideBarItem.label}
        style={{ fontFamily: "Montserrat" }}
        className={`${styles.sidebarListItem} ${
          pathname === sideBarItem.content ? styles.active : ""
        }`}
        onClick={onClick}
        primaryText={sideBarItem.label}
        containerElement={
          <Link
            to={sideBarItem.content}
            target={sideBarItem.external ? "_blank" : undefined}
          />
        }
      />
    );
  } else if (_.isArray(sideBarItem.content)) {
    return (
      <ListItem
        key={sideBarItem.label}
        primaryText={sideBarItem.label}
        style={{ fontFamily: "Montserrat" }}
        primaryTogglesNestedList
        initiallyOpen={sideBarItem.initiallyOpen}
        nestedItems={_.filter(
          _.map(
            // filter out undefined values
            sideBarItem.content,
            (nestedItem) =>
              getListContent(nestedItem, currentUserPermissions, onClick)
          )
        )}
      />
    );
  }
};

export default function SideBarList({ currentUser, onClick }) {
  const currentUserPermissions = userService.getUserPermissions(currentUser);
  return (
    <List className={styles.sideBarList_main}>
      <Divider />
      {_.filter(
        _.map(sideBarItemsList, (sideBarItem) => {
          // filter out undefined values
          const listContent = getListContent(
            sideBarItem,
            currentUserPermissions,
            onClick
          );
          if (!listContent) return;
          return (
            <div key={sideBarItem.label}>
              {listContent}
              <Divider />
            </div>
          );
        })
      )}
    </List>
  );
}



// WEBPACK FOOTER //
// ./src/layouts/CoreLayout/SideBarList.js